import React from "react";
import {Grid, Typography, TypographyProps} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {PortTheme} from "~/ui/theme";
import {FiberManualRecord} from "@mui/icons-material";


export type StatusBadgeProps<C = any> = Omit<TypographyProps<"div">, "children" | "className"> & {
    children: C
    outlined?: boolean
    badgeColor?: any
    className?: any
}


const defaultProps: Partial<StatusBadgeProps> = {
    outlined: true
}


const useStyles = makeStyles<PortTheme, StatusBadgeProps>(theme => ({
    root: {
        display: "inline-block",
        borderWidth: ({outlined}) => outlined ? 1 : 0,
        borderColor: "currentColor",
        borderStyle: "solid",
        borderRadius: 4,
        padding: props => props.outlined ? "2px 6px" : "0",
    },
    icon: {
        width: 9,
        height: 9,
        color: props => props.badgeColor,
        marginRight: 6,
    },
}))


export const StatusBadge = (props: StatusBadgeProps) => {
    const classes = useStyles(props);
    const {children, outlined, badgeColor, ...otherProps} = props;
    return (
        <Typography variant="cardText" {...otherProps} component="div">
            <Grid container alignItems="center">
                <FiberManualRecord fontSize="inherit" className={classes.icon}/>
                <div className={classes.text}>
                    {children}
                </div>
            </Grid>
        </Typography>
    )
}


StatusBadge.defaultProps = defaultProps;